module.exports = "<div class=\"ot-price-badge-noborder\">\n  <p>\n    <!-- <span>{{'EVENT.COST' | translate}}</span> -->\n    <span ng-if=\"params.event.price_per_person<=0\">{{'EVENT.COST_FREE' | translate}}</span>\n    <span ng-if=\"params.event.price_per_person>0\">{{(params.event.price_per_person / 100) | currency:\"$\":0}}</span>\n  </p>\n  <ot-rsvp class=\"row\"></ot-rsvp>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/directives/content/priceBadge.html
 ** module id = 272
 ** module chunks = 1
 **/